export enum EnumEstadoCliente {
  Borrador = 1,
  Iniciado = 2,
  Aceptado = 3,
  Rechazado = 4,
  Activo = 5,
  Anulado = 6,
  Baja = 7,
  PendienteActivacion = 8,
  PendienteBaja = 9,
  Cortado = 10,
  Inactivo = 11,
  Continuado = 12,
  PendienteCorte = 13,
  PendienteReengache = 14,
  PendienteModificacion = 15,
  SalienteCambioTitular = 16,
  PendienteCambioTitular = 17,
  PendienteDesistimiento = 18,
  PendienteReposicion = 19,
  BajaFutura = 20,
  BajaTemporal = 100,
  ActivoSaliente = 101
}
